import React, { Component } from 'react';
import './landing.css'
import Navbar, {scroll} from "./navbar";


export default class landing extends Component {
    constructor(props) {
        super(props);
        window.addEventListener('scroll', scroll, true);
      }
    render() {
        
        return (
            <div >
                <div class="banner">
                    <div class="back">
                    <Navbar />
                    <div class="content" id="about">
                        <svg class="title-show" viewBox="0 0 1320 300">
                            <text x="50%" y="50%" dy=".35em" text-anchor="middle">
                                Welcome To Study Date
                            </text>
                        </svg>
                        <div class="title-hidden">
                            <svg viewBox="0 0 1320 300">
                                <text x="50%" y="50%" dy=".35em" text-anchor="middle">
                                    Welcome To
                                </text>
                            </svg>
                            <svg viewBox="0 0 1320 300">
                                <text x="50%" y="60%" dy=".35em" text-anchor="middle">
                                    Study Date
                                </text>
                            </svg>
                        </div>
                        <p> We combine studying with online dating to offer a unique experience!<br /></p>
                        <div>
                            <a class="lbutton" href="./login" ><span></span>Login</a>
                            <a class="lbutton" href="./signup" ><span></span>Signup</a>

                        </div>
                    </div>
                    </div>
                    
                    <section class="service-section py-5" id="features">
                        <div class="container">
                            <div class="row justify-content-center py-3">
                                <div class="col-md-8 col-12 text-center">
                                    <p class="service-main-heading right-to-left">Features</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-12">
                                    <div class="icon-box">
                                        <i class="fa fa-briefcase service-icon"></i>
                                        <p class="service-title"><a href="#">Offers Convenience And Flexibility</a></p>
                                        <p class="service-para">Most professionals found they couldn’t continue with their education or upskilling because they couldn’t fit studies around their work schedules. Those shifting to online learning platforms will find that online learning offers convenience and flexibility in timings and pace, allowing you to learn in your own time</p>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
                                    <div class="icon-box">
                                        <i class="fa fa-clipboard service-icon"></i>
                                        <p class="service-title"><a href="#">High-Quality Student-Tutor and Student-Student Interactions</a></p>
                                        <p class="service-para">Online learning allows for better quality interactions between students and tutors.Most online learning courses that rely on live streaming have a cap on the number of students who can enroll, ensuring that each student gets adequate attention and advice from their tutor</p>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
                                    <div class="icon-box">
                                    <i class="fa fa-envelope-o fa-2x service-icon"></i>
                                        <p class="service-title"><a href="#">Better Learning Experience</a></p>
                                        <p class="service-para">Given that students are allowed to learn at their own pace and are encouraged to gain hands-on experience over memorizing textbooks, online learning can offer a better learning experience. It also helps that students can attend classes from places they’re comfortable being in, which makes them more likely to approach learning with a positive attitude.</p>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
                                    <div class="icon-box">
                                        <i class="fa fa-binoculars service-icon" style={{ marginTop: "0px" }}></i>
                                        <p class="service-title"><a href="#">More Cost-Effective</a></p>
                                        <p class="service-para">Online learning is priced lower than traditional university courses and is also worth the cost. The fees often don’t account for accommodation, textbooks, equipment, groceries, transport and other factors that contribute to the full learning experience in traditional schooling. Online learning slashes most of these costs at least by half, leaving students to make the most of the affordable prices they’ve paid.</p>
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
                                    <div class="icon-box">
                                        <i class="fa fa-cog service-icon" ></i>
                                        <p class="service-title"><a href="#">Retention Rates Are Higher</a></p>
                                        <p class="service-para">According to studies, retention rates are higher in online learning than in traditional university courses. This is likely due to the decrease in stressors and pressures otherwise present in traditional schooling systems. Students are allowed to learn and practice at their own pace; their course material is also available for a lifetime, in case they want to come back and refresh their memory.

                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
                                    <div class="icon-box">
                                        <i class="fa fa-clipboard service-icon" ></i>
                                        <p class="service-title"><a href="#">Increase in Web-based Learning</a></p>
                                        <p class="service-para">As time goes on and social distancing rules become more concrete in everyday life, it’s expected that web-based learning will experience a surge. Web-based learning includes a variety of setups including live streaming, video-on-demand, seminars, webinars, talk shows, interviews, and more.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>);
    }

}